
/* ChefDiem carousel: user-driven motion only. */
(function(){
  "use strict";
  function setup(section){
    const track=section.querySelector("[data-cd-reviews-track]");
    const prev=section.querySelector("[data-cd-reviews-prev]");
    const next=section.querySelector("[data-cd-reviews-next]");
    const counter=section.querySelector("[data-cd-reviews-counter]");
    if(!track||!prev||!next||!counter)return;
    const cards=Array.from(track.querySelectorAll(".cd-reviews__card"));
    if(!cards.length){section.hidden=true;return;}
    const fmt=n=>String(n).padStart(2,"0");
    const reduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function getOffsets(){
      const base=cards[0].offsetLeft;
      return cards.map(card=>card.offsetLeft-base);
    }
    function currentIndex(){
      const x=track.scrollLeft;
      const offsets=getOffsets();
      let idx=0,distance=Infinity;
      offsets.forEach((left,i)=>{const d=Math.abs(left-x);if(d<distance){distance=d;idx=i;}});
      return idx;
    }
    function update(){
      const i=currentIndex();
      const maxScroll=Math.max(0,track.scrollWidth-track.clientWidth);
      prev.disabled=track.scrollLeft<=2;
      next.disabled=track.scrollLeft>=maxScroll-2;
      counter.textContent=fmt(i+1)+" / "+fmt(cards.length);
    }
    function move(dir){
      const idx=currentIndex();
      const step=Math.max(1,cards[0].getBoundingClientRect().width+11);
      const by=dir*step;
      const nextIdx=Math.max(0,Math.min(cards.length-1,idx+dir));
      const offsets=getOffsets();
      let target=offsets[nextIdx];
      if(Math.abs(target-track.scrollLeft)<3){target=track.scrollLeft+by;}
      track.scrollTo({left:Math.max(0,target),behavior:reduced?"auto":"smooth"});
    }
    prev.addEventListener("click",()=>move(-1));
    next.addEventListener("click",()=>move(1));
    let pending=false;
    track.addEventListener("scroll",()=>{
      if(pending)return;
      pending=true;
      requestAnimationFrame(()=>{pending=false;update();});
    },{passive:true});
    window.addEventListener("resize",update,{passive:true});
    update();
  }
  function initialize(){document.querySelectorAll("[data-cd-reviews]").forEach(el=>{if(el.dataset.carouselInitialized)return;el.dataset.carouselInitialized="1";setup(el);});}
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initialize,{once:true});else initialize();
  document.addEventListener("shopify:section:load",initialize);
})();
